import { NgIf } from '@angular/common';
import {
  Component,
  inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import {
  AirportDropDownList,
  CheckInWidgetComponent
} from '@com-delta-idp/mnx-capability-check-in-ui';
import {
  AirportDropdownComponent,
  AnalyticsDataPopulateService,
  CheckInStaticAem
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { CityData } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { CheckInFacade } from '../data-access/facades/check-in.facade';
import { CHECK_IN_SMART_CONSTANTS } from '../data-access/models/check-in-status.constants';
@Component({
  selector: 'idp-check-in-container',
  standalone: true,
  imports: [NgIf, CheckInWidgetComponent, AirportDropdownComponent],
  templateUrl: './check-in.component.html',
  styleUrls: ['./check-in.component.scss']
})
export class CheckInContainerComponent implements OnInit, OnChanges {
  @Input() isSelected = false;
  @Input() content!: CheckInStaticAem | undefined;
  errorMessage =
    CHECK_IN_SMART_CONSTANTS.ERROR_MESSAGES.AEM_CONTENT_UNAVAILABLE_ERROR;

  facade = inject(CheckInFacade);
  airportSelected: AirportDropDownList = { code: '', name: '' };
  openModalEvent = false;
  lastApiCall = '';
  resetErrorsTrigger = 0;
  analyticsService = inject(AnalyticsDataPopulateService);
  private isPrefilledValue = false;

  handleAnalytics(element: HTMLElement): void {
    this.analyticsService.populateAnalyticsData(element);
  }

  ngOnInit(): void {
    this.facade.init(this.content);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isSelected']?.currentValue) {
      this.resetErrorsTrigger++;
    }
  }

  openModal(value: boolean): void {
    this.openModalEvent = value;
    if (value) {
      this.lastApiCall = '';
      this.facade.predictiveCities = [];
      this.isPrefilledValue = true;
    }
  }

  searchForAirport(searchTerm: string): void {
    this.facade.airportSearchErrorService.clearError();
    if (this.isPrefilledValue) {
      this.isPrefilledValue = false;
      return;
    }
    if (this.checkInvalidInput(searchTerm)) {
      this.handleInvalidInput(searchTerm);
      return;
    }
    if (searchTerm.length !== 3) return;
    this.performAirportSearch(searchTerm);
  }

  private performAirportSearch(searchTerm: string): void {
    const searchQuery = searchTerm.substring(0, 3);
    if (this.lastApiCall === searchQuery) {
      this.handleErrorForDuplicateSearch(searchQuery);
      return;
    }
    this.lastApiCall = searchQuery;
    this.facade.predictiveCities = [];
    this.facade.searchForAirport(searchQuery);
  }

  checkInvalidInput(searchText: string) {
    const alphabetRegex = /^[a-zA-Z.\s]+$/;
    return !alphabetRegex.test(searchText);
  }

  handleInvalidInput(searchTerm: string): void {
    this.lastApiCall = '';
    this.facade.predictiveCities = [];
    this.openModalEvent = false;
    setTimeout(() => {
      this.facade.airportModalContent.set(
        this.facade.adapter.initializeAirportModalContent([])
      );
      this.facade.airportSearchErrorService.handleEmptyResults(0, searchTerm);
      this.openModalEvent = true;
    }, 100);
  }

  private handleErrorForDuplicateSearch(searchQuery: string): void {
    if (this.facade.airportSearchErrorService._errorFlag) {
      this.facade.airportSearchErrorService.handleEmptyResults(0, searchQuery);
    }
  }

  onAirportSelected(airport: CityData | AirportDropDownList): void {
    if (this.isCityData(airport)) {
      this.airportSelected = this.convertCityDataToAirportDropDown(airport);
    } else {
      this.airportSelected = airport;
    }
  }

  private isCityData(
    airport: CityData | AirportDropDownList
  ): airport is CityData {
    return 'id' in airport && 'label' in airport;
  }

  private convertCityDataToAirportDropDown(
    city: CityData
  ): AirportDropDownList {
    return this.facade.convertCityDataToAirportDropDown(city);
  }
}
